import {connect} from "react-redux";
import DockList from "./DockList";
import {
  dockListEventHandler,
  dockListProps,
} from "../common-comps/dock";
import {getComputedDockListMovingTomorrow} from "../../selectors/dock";
import {withRouter} from "react-router-dom";

export const DockListMovingTomorrow = withRouter(connect(
  state => dockListProps(
    state,
    getComputedDockListMovingTomorrow(state),
    "Tournées en préparation POUR DEMAIN"
  ),
  dispatch => dockListEventHandler(dispatch)
)(DockList));
